import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { ContractStatus, contractStatusOrdered } from '@app/features/contracts/contract.model';

export interface DisplayableForContractStatusInput {
  currentStatus: ContractStatus;
  otherStatus: ContractStatus;
}

@Directive({
  selector: '[appDisplayableForContractStatus]',
  standalone: true,
})
export class DisplayableForContractStatusDirective {
  private hasView = false;
  private currentStatus: ContractStatus | null = null;
  private otherStatus: ContractStatus | null = null;

  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly templateRef = inject(TemplateRef<unknown>);

  @Input()
  set appDisplayableForContractStatus(value: DisplayableForContractStatusInput | null) {
    if (!value) {
      this.currentStatus = null;
      this.otherStatus = null;
      this.renderAlways();
      return;
    }

    this.currentStatus = value.currentStatus;
    this.otherStatus = value.otherStatus;
    this.updateView();
  }

  private updateView(): void {
    if (this.currentStatus === null || this.otherStatus === null) {
      return;
    }

    const currentIndex = contractStatusOrdered.indexOf(this.currentStatus);
    const otherIndex = contractStatusOrdered.indexOf(this.otherStatus);
    const displayable =
      currentIndex === -1 || otherIndex === -1 || Math.abs(currentIndex - otherIndex) <= 3;

    if (displayable && !this.hasView) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.hasView = true;
      return;
    }

    if (!displayable && this.hasView) {
      this.viewContainerRef.clear();
      this.hasView = false;
    }
  }

  private renderAlways(): void {
    if (!this.hasView) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }
  }
}
